var map = {
	"./icon_payment_american_express.svg": "2bbc",
	"./icon_payment_bancontact.svg": "de81",
	"./icon_payment_mastercard.svg": "fe5b",
	"./icon_payment_visa.svg": "f702"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "39d0";